const prebootLines = [
    'loading hardened syscall table',
    'initializing secure memory regions',
    'mounting encrypted workspace',
    'verifying execution integrity',
    'secure environment ready',
];

export default prebootLines;
